import { render, staticRenderFns } from "./store-info.vue?vue&type=template&id=3ffae97c&scoped=true"
import script from "./store-info.vue?vue&type=script&lang=js"
export * from "./store-info.vue?vue&type=script&lang=js"
import style0 from "./store-info.vue?vue&type=style&index=0&id=3ffae97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffae97c",
  null
  
)

export default component.exports